<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><a id="pagev"></a>Contents</p>
<table width="100%">
<colgroup>
<col width="15%"/>
<col width="85%"/>
</colgroup>
<tbody>
<tr>
<td valign="top"> </td>
<td valign="top"><a href="#/05_map#map" id="rmap"><em>Map</em></a></td>
</tr>
<tr>
<td valign="top"> </td>
<td valign="top"><a href="#/06_introduction#introduction" id="rintroduction"><em>Introduction</em></a></td>
</tr>
<tr>
<td valign="top"> </td>
<td valign="top"><a href="#/07_preface#preface" id="rpreface"><em>Preface</em></a></td>
</tr>
<tr>
<td align="right" valign="top"><a href="#/08_chapter1#ch01" id="rch01">I</a></td>
<td valign="top"><a href="#/08_chapter1#ch01">The Second Battle of Barfleur</a></td>
</tr>
<tr>
<td align="right" valign="top"><a href="#/09_chapter2#ch02" id="rch02">II</a></td>
<td valign="top"><a href="#/09_chapter2#ch02">Conditioning for War</a></td>
</tr>
<tr>
<td align="right" valign="top"><span href="#/10_chapter3#ch03" id="rch03" title="Link target outside of Sample">III</span></td>
<td valign="top"><span href="#/10_chapter3#ch03" title="Link target outside of Sample">Coastal Forces</span></td>
</tr>
<tr>
<td align="right" valign="top"><span href="#/11_chapter4#ch04" id="rch04" title="Link target outside of Sample">IV</span></td>
<td valign="top"><span href="#/11_chapter4#ch04" title="Link target outside of Sample">Getting the Hang of It</span></td>
</tr>
<tr>
<td align="right" valign="top"><span href="#/12_chapter5#ch05" id="rch05" title="Link target outside of Sample">V</span></td>
<td valign="top"><span href="#/12_chapter5#ch05" title="Link target outside of Sample">Hellrot</span></td>
</tr>
<tr>
<td align="right" valign="top"><span href="#/13_chapter6#ch06" id="rch06" title="Link target outside of Sample">VI</span></td>
<td valign="top"><span href="#/13_chapter6#ch06" title="Link target outside of Sample">Iron Ore</span></td>
</tr>
<tr>
<td align="right" valign="top"><span href="#/14_chapter7#ch07" id="rch07" title="Link target outside of Sample">VII</span></td>
<td valign="top"><span href="#/14_chapter7#ch07" title="Link target outside of Sample">Softly Catch Monkey</span></td>
</tr>
<tr>
<td align="right" valign="top"><span href="#/15_chapter8#ch08" id="rch08" title="Link target outside of Sample">VIII</span></td>
<td valign="top"><span href="#/15_chapter8#ch08" title="Link target outside of Sample">‘Expect Unsuccessful Attack’</span></td>
</tr>
<tr>
<td align="right" valign="top"><span href="#/16_chapter9#ch09" id="rch09" title="Link target outside of Sample">IX</span></td>
<td valign="top"><span href="#/16_chapter9#ch09" title="Link target outside of Sample">Back to <em>Beehive</em></span></td>
</tr>
<tr>
<td align="right" valign="top"><span href="#/17_chapter10#ch10" id="rch10" title="Link target outside of Sample">X</span></td>
<td valign="top"><span href="#/17_chapter10#ch10" title="Link target outside of Sample">The Barrels and the Bullfight</span></td>
</tr>
<tr>
<td align="right" valign="top"><span href="#/18_chapter11#ch11" id="rch11" title="Link target outside of Sample">XI</span></td>
<td valign="top"><span href="#/18_chapter11#ch11" title="Link target outside of Sample">The Four Horsemen</span></td>
</tr>
<tr>
<td align="right" valign="top"><span href="#/19_chapter12#ch12" id="rch12" title="Link target outside of Sample">XII</span></td>
<td valign="top"><span href="#/19_chapter12#ch12" title="Link target outside of Sample">Hits and Near Misses</span></td>
</tr>
<tr>
<td align="right" valign="top"><span href="#/20_chapter13#ch13" id="rch13" title="Link target outside of Sample">XIII</span></td>
<td valign="top"><span href="#/20_chapter13#ch13" title="Link target outside of Sample">Sad Ending</span></td>
</tr>
<tr class="spaceUper">
<td align="right" valign="top"> </td>
<td valign="top"><span href="#/21_appendix1#app1" title="Link target outside of Sample"><em>Appendice</em></span></td>
</tr>
<tr>
<td align="right" valign="top"><span href="#/21_appendix1#app1" id="rapp1" title="Link target outside of Sample">I</span></td>
<td valign="top"><span href="#/21_appendix1#app1" title="Link target outside of Sample">British Ships and Craft</span></td>
</tr>
<tr>
<td align="right" valign="top"><span href="#/22_appendix2#app2" id="rapp2" title="Link target outside of Sample">II</span></td>
<td valign="top"><span href="#/22_appendix2#app2" title="Link target outside of Sample">Operational Statistics</span></td>
</tr>
<tr>
<td align="right" valign="top"><span href="#/23_appendix3#app3" id="rapp3" title="Link target outside of Sample">III</span></td>
<td valign="top"><span href="#/23_appendix3#app3" title="Link target outside of Sample">Enemy Ships and Craft</span></td>
</tr>
<tr>
<td valign="top"> </td>
<td valign="top"><span href="#/24_bibliography#bibliography" id="rbibliography" title="Link target outside of Sample"><em>Bibliography</em></span></td>
</tr>
<tr>
<td valign="top"> </td>
<td valign="top"><span href="#/25_index#index" id="rindex" title="Link target outside of Sample"><em>Index</em></span></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_contents.vue?00252278